export default __webpack_public_path__ + "static/media/runkeeper-track-before-1.f56e27aa.svg";